module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/paliwo@2x-3612ce21.png";